import { Dispatch, Action } from 'redux';
import axios from 'axios';
import { Team } from '../reducers/teams.reducer'
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
// import { NotificationManager } from 'react-notifications';
import { getTeamAPI, getTeamsAPI, addTeamAPI, editTeamAPI, deleteTeamAPI } from '../../config/config'
import { toast } from 'react-toastify'


// Action types
export const GET_TEAMS_REQUEST = 'GET_TEAMS_REQUEST';
export const GET_TEAMS_SUCCESS = 'GET_TEAMS_SUCCESS';
export const GET_TEAMS_FAILURE = 'GET_TEAMS_FAILURE';

export const GET_TEAM_REQUEST = 'GET_TEAM_REQUEST';
export const GET_TEAM_SUCCESS = 'GET_TEAM_SUCCESS';
export const GET_TEAM_FAILURE = 'GET_TEAM_FAILURE';

export const ADD_TEAM_REQUEST = 'ADD_TEAM_REQUEST';
export const ADD_TEAM_SUCCESS = 'ADD_TEAM_SUCCESS';
export const ADD_TEAM_FAILURE = 'ADD_TEAM_FAILURE';

export const EDIT_TEAM_REQUEST = 'EDIT_TEAM_REQUEST';
export const EDIT_TEAM_SUCCESS = 'EDIT_TEAM_SUCCESS';
export const EDIT_TEAM_FAILURE = 'EDIT_TEAM_FAILURE';

export const DELETE_TEAM_REQUEST = 'DELETE_TEAM_REQUEST';
export const DELETE_TEAM_SUCCESS = 'DELETE_TEAM_SUCCESS';
export const DELETE_TEAM_FAILURE = 'DELETE_TEAM_FAILURE';

export const SET_ADD_TEAM_POPUP = 'SET_ADD_TEAM_POPUP';
export const SET_EDIT_TEAM_POPUP = 'SET_EDIT_TEAM_POPUP';
export const SET_DELETE_TEAM_POPUP = 'SET_DELETE_TEAM_POPUP';

export const RESET_TEAM_STATE = 'RESET_TEAM_STATE'

export interface AddTeamProps {
  name: string;
  alocatedValidations: number;
  companyUuid: string
  allowsPrivacy: boolean;
}

export interface EditTeamProps {
  name: string;
  alocatedValidations: number;
  companyUuid: string
  allowsPrivacy: boolean
}

interface DeleteTeamProps {
  target: string | number;
}

interface GetTeamsRequest extends Action<typeof GET_TEAMS_REQUEST> { }
interface GetTeamsSuccess extends Action<typeof GET_TEAMS_SUCCESS> {
  payload: Team[]
}
interface GetTeamsFailure extends Action<typeof GET_TEAMS_FAILURE> {
  payload: string
}

interface GetTeamRequest extends Action<typeof GET_TEAM_REQUEST> { }
interface GetTeamSuccess extends Action<typeof GET_TEAM_SUCCESS> {
  payload: Team
}
interface GetTeamFailure extends Action<typeof GET_TEAM_FAILURE> {
  payload: string
}

interface AddTeamRequest extends Action<typeof ADD_TEAM_REQUEST> { }
interface AddTeamSuccess extends Action<typeof ADD_TEAM_SUCCESS> { }
interface AddTeamFailure extends Action<typeof ADD_TEAM_FAILURE> {
  payload: string
}

interface EditTeamRequest extends Action<typeof EDIT_TEAM_REQUEST> { }
interface EditTeamSuccess extends Action<typeof EDIT_TEAM_SUCCESS> { }
interface EditTeamFailure extends Action<typeof EDIT_TEAM_FAILURE> {
  payload: string
}

interface DeleteTeamRequest extends Action<typeof DELETE_TEAM_REQUEST> { }
interface DeleteTeamSuccess extends Action<typeof DELETE_TEAM_SUCCESS> { }
interface DeleteTeamFailure extends Action<typeof DELETE_TEAM_FAILURE> {
  payload: string
}

interface SetAddPLanPopUp extends Action<typeof SET_ADD_TEAM_POPUP> {
  payload: boolean;
}

interface SetEditPLanPopUp extends Action<typeof SET_EDIT_TEAM_POPUP> {
  payload: boolean;
}

interface SetDeletePLanPopUp extends Action<typeof SET_DELETE_TEAM_POPUP> {
  payload: boolean;
}

interface ResetTeamState extends Action<typeof RESET_TEAM_STATE> {}

export type ActionTypes = GetTeamsRequest | GetTeamsSuccess | GetTeamsFailure
  | GetTeamRequest | GetTeamSuccess | GetTeamFailure
  | AddTeamRequest | AddTeamSuccess | AddTeamFailure
  | EditTeamRequest | EditTeamSuccess | EditTeamFailure
  | DeleteTeamRequest | DeleteTeamSuccess | DeleteTeamFailure
  | SetAddPLanPopUp | SetEditPLanPopUp | SetDeletePLanPopUp
  | ResetTeamState

// Action creators
const getTeamsRequest = (): GetTeamsRequest => ({ type: GET_TEAMS_REQUEST });
const getTeamsSuccess = (data: Team[]): GetTeamsSuccess => ({ type: GET_TEAMS_SUCCESS, payload: data });
const getTeamsFailure = (error: string): GetTeamsFailure => ({ type: GET_TEAMS_FAILURE, payload: error });

const getTeamRequest = (): GetTeamRequest => ({ type: GET_TEAM_REQUEST });
const getTeamSuccess = (data: Team): GetTeamSuccess => ({ type: GET_TEAM_SUCCESS, payload: data });
const getTeamFailure = (error: string): GetTeamFailure => ({ type: GET_TEAM_FAILURE, payload: error });

const addTeamRequest = (): AddTeamRequest => ({ type: ADD_TEAM_REQUEST });
const addTeamSuccess = (): AddTeamSuccess => ({ type: ADD_TEAM_SUCCESS });
const addTeamFailure = (error: string): AddTeamFailure => ({ type: ADD_TEAM_FAILURE, payload: error });

const editTeamRequest = (): EditTeamRequest => ({ type: EDIT_TEAM_REQUEST });
const editTeamSuccess = (): EditTeamSuccess => ({ type: EDIT_TEAM_SUCCESS });
const editTeamFailure = (error: string): EditTeamFailure => ({ type: EDIT_TEAM_FAILURE, payload: error });

const deleteTeamRequest = (): DeleteTeamRequest => ({ type: DELETE_TEAM_REQUEST });
const deleteTeamSuccess = (): DeleteTeamSuccess => ({ type: DELETE_TEAM_SUCCESS });
const deleteTeamFailure = (error: string): DeleteTeamFailure => ({ type: DELETE_TEAM_FAILURE, payload: error });

const setAddTeamPopup = (value: boolean): SetAddPLanPopUp => ({ type: SET_ADD_TEAM_POPUP, payload: value });
const setEditTeamPopup = (value: boolean): SetEditPLanPopUp => ({ type: SET_EDIT_TEAM_POPUP, payload: value });
const setDeleteTeamPopup = (value: boolean): SetDeletePLanPopUp => ({ type: SET_DELETE_TEAM_POPUP, payload: value });

const resetTeamState = (): ResetTeamState => ({type:RESET_TEAM_STATE})


// Async action creators
const getTeams = (uuid: string) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(resetTeamState()); 
      dispatch(getTeamsRequest());
      const response = await getTeamsAPI(uuid)
      dispatch(getTeamsSuccess(response?.data?.teams || []))

    } catch (error: any) {
      console.log('error', error)
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(getTeamsFailure(error.message));
    }
  };
};

const getTeam = (uuid: string) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(getTeamRequest());
      const response = await getTeamAPI(uuid)
      dispatch(getTeamSuccess(response?.data?.company || {}))

    } catch (error: any) {
      console.log('error', error)
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(getTeamFailure(error.message));
    }
  };
};

const addTeam = (data: AddTeamProps): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    try {
      dispatch(addTeamRequest());

      const response = await addTeamAPI(data)
      if (response.status === 200) {
        toast.success('Team Saved')
    } else {
        toast.error(response?.data?.message || 'Error Saving')
    }
      dispatch(addTeamSuccess());
      dispatch(getTeams(data?.companyUuid)); // Call the getTeams action after adding a team
      dispatch(setAddTeamPopup(false))
    } catch (error: any) {
      console.log('error', error);
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(addTeamFailure(error.message));
    }
  };
};

const editTeam = (data: EditTeamProps, uuid: string): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  const token = window.localStorage.getItem('token');
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    try {
      dispatch(editTeamRequest());
      const response = await editTeamAPI(data, uuid)
      if (response.status === 200) {
        toast.success('Team Saved')
    } else {
        toast.error(response?.data?.message || 'Error Saving')
    }
      dispatch(editTeamSuccess());
      dispatch(getTeams(data?.companyUuid)); // Call the getTeams action after adding a team
      dispatch( updateEditTeamPopup(false))
    } catch (error: any) {
      console.log('error', error);
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(editTeamFailure(error.message));
    }
  };
};

const deleteTeam = (uuid: string, cUuid: string): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    try {
      dispatch(deleteTeamRequest());
      const response = await deleteTeamAPI(uuid)
      dispatch(deleteTeamSuccess());
      dispatch(getTeams(cUuid)); // Call the getTeams action after adding a team
      dispatch(updateDeleteTeamPopup(false))
    } catch (error: any) {
      console.log('error', error);
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(deleteTeamFailure(error.message));
    }
  };
};

const updateAddTeamPopup = (value: boolean): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(setAddTeamPopup(value))
  };
}

const updateEditTeamPopup = (value: boolean): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(setEditTeamPopup(value))
  };
}

const updateDeleteTeamPopup = (value: boolean): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(setDeleteTeamPopup(value))
  };
}

const resetAll = (): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(resetTeamState())
  };
}


const actions = {
  getTeams,
  addTeam,
  editTeam,
  getTeam,
  deleteTeam,
  updateAddTeamPopup,
  updateEditTeamPopup,
  updateDeleteTeamPopup,
  resetAll
}

export default actions
